"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var map_exports = {};
__export(map_exports, {
  FALLBACK_CALENDAR: () => FALLBACK_CALENDAR,
  FALLBACK_LOCALE: () => FALLBACK_LOCALE,
  toCalendar: () => toCalendar,
  toCalendars: () => toCalendars,
  toLocale: () => toLocale,
  toLocales: () => toLocales
});
module.exports = __toCommonJS(map_exports);
function toLocale(info) {
  var _info_languageCode, _info_languageScriptCode, _info_regionCode, _info_languageRegionCode, _info_currencyCode, _info_currencySymbol, _info_languageCurrencyCode, _info_languageCurrencySymbol, _info_decimalSeparator, _info_digitGroupingSeparator;
  return {
    languageTag: info.languageTag,
    languageCode: (_info_languageCode = info.languageCode) !== null && _info_languageCode !== void 0 ? _info_languageCode : null,
    languageScriptCode: (_info_languageScriptCode = info.languageScriptCode) !== null && _info_languageScriptCode !== void 0 ? _info_languageScriptCode : null,
    regionCode: (_info_regionCode = info.regionCode) !== null && _info_regionCode !== void 0 ? _info_regionCode : null,
    languageRegionCode: (_info_languageRegionCode = info.languageRegionCode) !== null && _info_languageRegionCode !== void 0 ? _info_languageRegionCode : null,
    currencyCode: (_info_currencyCode = info.currencyCode) !== null && _info_currencyCode !== void 0 ? _info_currencyCode : null,
    currencySymbol: (_info_currencySymbol = info.currencySymbol) !== null && _info_currencySymbol !== void 0 ? _info_currencySymbol : null,
    languageCurrencyCode: (_info_languageCurrencyCode = info.languageCurrencyCode) !== null && _info_languageCurrencyCode !== void 0 ? _info_languageCurrencyCode : null,
    languageCurrencySymbol: (_info_languageCurrencySymbol = info.languageCurrencySymbol) !== null && _info_languageCurrencySymbol !== void 0 ? _info_languageCurrencySymbol : null,
    decimalSeparator: (_info_decimalSeparator = info.decimalSeparator) !== null && _info_decimalSeparator !== void 0 ? _info_decimalSeparator : null,
    digitGroupingSeparator: (_info_digitGroupingSeparator = info.digitGroupingSeparator) !== null && _info_digitGroupingSeparator !== void 0 ? _info_digitGroupingSeparator : null,
    textDirection: info.textDirection === "rtl" ? "rtl" : "ltr",
    measurementSystem: info.measurementSystem === "metric" || info.measurementSystem === "us" || info.measurementSystem === "uk" ? info.measurementSystem : null,
    temperatureUnit: info.temperatureUnit === "celsius" || info.temperatureUnit === "fahrenheit" ? info.temperatureUnit : null
  };
}
function toCalendar(info) {
  var _info_calendar, _info_timeZone, _info_uses24hourClock, _info_firstWeekday;
  return {
    calendar: (_info_calendar = info.calendar) !== null && _info_calendar !== void 0 ? _info_calendar : null,
    timeZone: (_info_timeZone = info.timeZone) !== null && _info_timeZone !== void 0 ? _info_timeZone : null,
    uses24hourClock: (_info_uses24hourClock = info.uses24hourClock) !== null && _info_uses24hourClock !== void 0 ? _info_uses24hourClock : null,
    firstWeekday: (_info_firstWeekday = info.firstWeekday) !== null && _info_firstWeekday !== void 0 ? _info_firstWeekday : null
  };
}
var FALLBACK_LOCALE = {
  languageTag: "en-US",
  languageCode: "en",
  languageScriptCode: null,
  regionCode: "US",
  languageRegionCode: "US",
  currencyCode: null,
  currencySymbol: null,
  languageCurrencyCode: null,
  languageCurrencySymbol: null,
  decimalSeparator: null,
  digitGroupingSeparator: null,
  textDirection: "ltr",
  measurementSystem: null,
  temperatureUnit: null
};
var FALLBACK_CALENDAR = {
  calendar: "gregory",
  timeZone: null,
  uses24hourClock: null,
  firstWeekday: null
};
function toLocales(infos) {
  var locales = infos.map(toLocale);
  return locales.length > 0 ? locales : [
    FALLBACK_LOCALE
  ];
}
function toCalendars(infos) {
  var calendars = infos.map(toCalendar);
  return calendars.length > 0 ? calendars : [
    FALLBACK_CALENDAR
  ];
}
//# sourceMappingURL=map.js.map
